import { Landing } from "./pages/Landing";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PanelesSolaresAdvise from "./pages/PanelesLandingPage";
import PanelesPrivacyPolicy from "./pages/PanelesPrivacyPolicy";
import useWindowWidth from "./interceptors/WidthChecker";

function App() {

  const minNavbarWidth = 1150
  const width = useWindowWidth();
  const isLargeScreen = width > minNavbarWidth;

  return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={< Landing isLargeScreen={isLargeScreen}/>}></Route>
            <Route path="/SiGGER360" element={<PanelesSolaresAdvise isLargeScreen={isLargeScreen}/>}></Route>
            <Route path="/SiGGER360/privacyPolicy" element={<PanelesPrivacyPolicy isLargeScreen={isLargeScreen}/>}></Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
